import { Component, Input, OnInit } from '@angular/core';
import { Block, BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { TranslatePipe } from '@gallaghercp/core-frontend-contracts';

@Component({
    selector: 'core-fmla-only-results',
    templateUrl: './block-fmla-only-results.component.html',
    styleUrls: [
        '../../scss/block-leave-of-absence-tool-charts.scss',
        '../../scss/block-leave-of-absence-tool-questions.scss',
        '../../scss/block-leave-of-absence-tool-timeline.scss',
    ],
    imports: [TranslatePipe],
})
export class BlockFmlaOnlyResultsComponent extends BlockAbstractComponent implements OnInit {
    @Input() selectedAnswers: Record<string, any> = {};
    @Input() parentBlock: Block | undefined;

    // Section text strings
    introParagraphText!: string;
    lengthOfLeaveText!: string;
    payText!: string;
    processChecklist!: string;
    thingsToConsider!: string;

    override ngOnInit() {
        // Create a mapping of conditions to their corresponding intro paragraph text
        const introParagraphMapping = [
            {
                condition: this.fmlaOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.fmlaOnlyIntroParagraphLeaveQualified,
            },
            {
                condition: this.fmlaOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.fmlaOnlyIntroParagraphLeaveQualifiedInitiateInServiceNow,
            },
            {
                condition: this.fmlaOnlyNinetyDaysOrLess,
                text: this.parentBlock?.data.fmlaOnlyIntroParagraphLeaveNotQualified,
            },
        ];

        // Create a mapping of conditions to their corresponding length of leave text
        const lengthOfLeaveMapping = [
            {
                condition: this.fmlaOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.fmlaOnlyLengthOfLeaveUpToTwelveWeeks,
            },
            {
                condition: this.fmlaOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.fmlaOnlyLengthOfLeaveUpToSixtyDaysPersonalLeave,
            },
        ];

        // Create a mapping of conditions to their corresponding pay text
        const payMapping = [
            {
                condition: this.fmlaOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.fmlaOnlyPayTwelveWeeksUnpaidUsePaidLeave,
            },
            {
                condition: this.fmlaOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.fmlaOnlyPayPersonalLeaveUnPaidUseVacation,
            },
        ];

        // Create a mapping of conditions to their corresponding process list text
        const processListMapping = [
            {
                condition: this.fmlaOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.fmlaOnlyProcessListOne,
            },
            {
                condition: this.fmlaOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.fmlaOnlyProcessListTwo,
            },
        ];

        // Create a mapping of conditions to their corresponding things to consider text
        const thingsToConsiderMapping = [
            {
                condition: this.fmlaOnlyTwelveMonthsOrMore,
                text: this.parentBlock?.data.fmlaOnlyThingsToConsiderOne,
            },
            {
                condition: this.fmlaOnlyLessThanTwelveMonthsButMoreThanNinetyDays,
                text: this.parentBlock?.data.fmlaOnlyThingsToConsiderOne,
            },
            {
                condition: this.fmlaOnlyNinetyDaysOrLess,
                text: this.parentBlock?.data.fmlaOnlyThingsToConsiderTwo,
            },
        ];

        // Find the first matching condition and set the intro paragraph text
        const introParagraphMatch = introParagraphMapping.find(item => item.condition);
        if (introParagraphMatch) {
            this.introParagraphText = introParagraphMatch.text;
        }

        // Find the first matching condition and set the length of leave text
        const lengthOfLeaveMatch = lengthOfLeaveMapping.find(item => item.condition);
        if (lengthOfLeaveMatch) {
            this.lengthOfLeaveText = lengthOfLeaveMatch.text;
        }

        // Find the first matching condition and set the pay text
        const payMatch = payMapping.find(item => item.condition);
        if (payMatch) {
            this.payText = payMatch.text;
        }

        // Find the first matching condition and set the process list text
        const processListMatch = processListMapping.find(item => item.condition);
        if (processListMatch) {
            this.processChecklist = processListMatch.text;
        }

        // Find the first matching condition and set the things to consider text
        const thingsToConsiderMatch = thingsToConsiderMapping.find(item => item.condition);
        if (thingsToConsiderMatch) {
            this.thingsToConsider = thingsToConsiderMatch.text;
        }
        super.ngOnInit();
    }

    get fmlaOnlyTwelveMonthsOrMore(): boolean {
        return this.selectedAnswers['employedDuration'] == 'twelveMonthsOrMore';
    }

    get fmlaOnlyLessThanTwelveMonthsButMoreThanNinetyDays(): boolean {
        return this.selectedAnswers['employedDuration'] == 'lessThanTwelveMonthsButMoreThanNinetyDays';
    }

    get fmlaOnlyNinetyDaysOrLess(): boolean {
        return this.selectedAnswers['employedDuration'] == 'ninetyDaysOrLess';
    }
}
